import React, { Component } from 'react';
import Heading from './Heading'
import Subtext from './Subtext'
import Radium from 'radium';
import './css.css';

const styles = {
    container: {
        width: 200
    },
    subtext: {
        width: 200.
    },
}

class HeadingSubtextContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editModeIndex: undefined
        };
    }
    addRowIfNeeded = (index) => {
        const { headingSubtexts } = this.props
        if (index === headingSubtexts.length - 1) {
            this.props.addHeadingSubtext()
        }
    }
    updateH = (value, index) => {
        this.addRowIfNeeded(index)
        this.props.updateHeading(value, index)
    }
    updateS = (value, index) => {
        this.addRowIfNeeded(index)
        this.props.updateSubtext(value, index)
    }
    setEditMode = (value, index, hs) => {
        if (value) {
            this.setState({
                editModeIndex: index + '' + hs
            })
        } else {
            this.setState({
                editModeIndex: undefined
            })
        }
    }
    renderHeadingSubtexts = () => {
        const { headingSubtexts, dontAllowNewRow, noedit } = this.props
        return headingSubtexts.map((hs, index) => {
            if(!hs)
            return 
            let empty = !hs.heading || !hs.subtext
            if (empty && (dontAllowNewRow || noedit)) {
                return
            }
            return (
                <div style={[{ width: 220 }, this.props.subContainerStyle]} key={index}>
                    <Heading
                        text={hs.heading}
                        onChange={(value) => this.updateH(value, index)}
                        setEditMode={(value, hs) => this.setEditMode(value, index, hs)}
                        editMode={this.props.noedit ? false : (this.state.editModeIndex == index + '1' || !hs.heading)}
                        style={this.props.headingStyle}
                    />
                    <Subtext
                        style={styles.subtext}
                        text={hs.subtext}
                        onChange={(value) => this.updateS(value, index)}
                        setEditMode={(value, hs) => this.setEditMode(value, index, hs)}
                        editMode={this.props.noedit ? false : (this.state.editModeIndex == index + '2' || !hs.subtext)}
                        style={this.props.subtextStyle}
                    />
                </div>
            )
        })
    }
    render() {
        return (
            <div style={[styles.container, this.props.style]}>
                {this.renderHeadingSubtexts()}
            </div>
        );
    }
}

export default Radium(HeadingSubtextContainer)



// WEBPACK FOOTER //
// ./src/App/HeadingSubtext/HeadingSubtextContainer.js